module.exports = __webpack_public_path__ + "img/imposta-logo-hdtool.599e9c1c.png";